import { Selector } from '@ngxs/store';
import { StripeConnectState, StripeConnectStateModel } from './stripe-connect.state';
import { OnboardingStatus, StripeConnectStatus } from './stripe-connect.actions';
import { StripeCheckFailure } from '../domains/a-connect-account-no-retry-can-fix';

export class StripeConnectSelector {
  @Selector([StripeConnectState])
  static accountStatus(state: StripeConnectStateModel): StripeConnectStatus | null {
    return state.accountStatus;
  }

  @Selector([StripeConnectState])
  static onboardingStatus(state: StripeConnectStateModel): OnboardingStatus {
    return state.accountStatus?.status || 'not_started';
  }

  /**
   * Why the failure is selected and not derived from `onboardingStatus`: the
   * status is 'check_failed' for both failures, and only this says which.
   */
  @Selector([StripeConnectState])
  static checkFailure(state: StripeConnectStateModel): StripeCheckFailure | undefined {
    return state.accountStatus?.checkFailure;
  }

  @Selector([StripeConnectState])
  static isComplete(state: StripeConnectStateModel): boolean {
    return (
      state.accountStatus?.status === 'complete' &&
      state.accountStatus?.chargesEnabled === true &&
      state.accountStatus?.payoutsEnabled === true
    );
  }

  @Selector([StripeConnectState])
  static onboardingUrl(state: StripeConnectStateModel): string | null {
    return state.onboardingUrl;
  }

  @Selector([StripeConnectState])
  static isLoading(state: StripeConnectStateModel): boolean {
    return state.isLoading;
  }

  @Selector([StripeConnectState])
  static error(state: StripeConnectStateModel): string | null {
    return state.error;
  }

  @Selector([StripeConnectState])
  static chargesEnabled(state: StripeConnectStateModel): boolean {
    return state.accountStatus?.chargesEnabled || false;
  }

  @Selector([StripeConnectState])
  static payoutsEnabled(state: StripeConnectStateModel): boolean {
    return state.accountStatus?.payoutsEnabled || false;
  }

  @Selector([StripeConnectState])
  static accountId(state: StripeConnectStateModel): string | undefined {
    return state.accountStatus?.accountId;
  }

  @Selector([StripeConnectState])
  static validOnboardingUrl(state: StripeConnectStateModel): string | null {
    if (!state.onboardingUrl || !state.onboardingUrlExpiresAt) {
      return null;
    }
    const now = Date.now();
    if (now >= state.onboardingUrlExpiresAt) {
      return null;
    }
    return state.onboardingUrl;
  }
}
